export const GRAFANA_URL: string | undefined =
  import.meta.env.VITE_GRAFANA_URL || undefined;
export const LOKI_URL: string | undefined =
  import.meta.env.VITE_LOKI_URL || undefined;
export const SCHEDULER_RUNS_NOTE = "Completed runs, not live heartbeats.";
